import {ResizeObserver as Polyfill} from '@juggle/resize-observer'

export const render = () => {
    var contentHeight = document.querySelector('.bio-single .info-container').clientHeight

    const ResizeObserver = window.ResizeObserver || Polyfill

    const ro = new ResizeObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.contentRect.width >= 1024 && entry.contentRect.width < 1200) {
                document.querySelector('.bio-single .info-container').style.height = (contentHeight - 400) + 'px'
            } 
            if (entry.contentRect.width >= 1200) {
                document.querySelector('.bio-single .info-container').style.height = (contentHeight - 500) + 'px'
            } else if (entry.contentRect.width < 1024) {
                document.querySelector('.bio-single .info-container').style.height = 'auto'
            }
        })
      })
      ro.observe(document.body); // Watch dimension changes on body


    // animations
    var blueBox = document.querySelector('.blue-box'),
        crown = document.querySelector('.crown'),
        lightning = document.querySelector('.lightning'),
        stars = document.querySelector('.stars')

    blueBox.classList.add('transitionIn')

    setTimeout(() => {
        lightning.classList.add('animated', 'bounce', 'infinite')
    }, 1000)
    setTimeout(() => {
        crown.classList.add('animated', 'swing')
        stars.classList.add('animated', 'pulse', 'infinite')
    }, 2000)
}